import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=7199e8b7&scoped=true"
import script from "./AdminClients.vue?vue&type=script&lang=js"
export * from "./AdminClients.vue?vue&type=script&lang=js"
import style0 from "./AdminClients.vue?vue&type=style&index=0&id=7199e8b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7199e8b7",
  null
  
)

export default component.exports